import React, { useState } from "react";
import { auth, db } from "../firebase";
import {
  getAuth,
  onAuthStateChanged,
  getUser,
  getIdTokenResult,
} from "firebase/auth";

import { Container, Button, Row, Form, Col } from "react-bootstrap";

//const auth = getAuth();

const TestFunctions = () => {
  const [response, setResponse] = useState("");
  const [currentUser, setCurrentUser] = useState("");
  // const auth = getAuth();
  // const user = auth.currentUser;
  // setCurrentUser(user);

  async function getUserRole() {
    const auth = getAuth();
    console.log("Auth.CurrentUser is", auth.currentUser.uid);
    currentUser
      .getIdTokenResult()
      .then((idTokenResult) => {
        // Confirm the user is an Admin.
        console.log("idTokenResults is:", idTokenResult.claims.role);
        let roleToken = "";
        roleToken = idTokenResult.claims.role;
        const uidToken = idTokenResult.claims.uid;
        console.log("idRoleToken is:", roleToken);
        console.log("uidToken is:", uidToken);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  async function getUserRecord() {
    //let theUserUid = "7EeRFdVUAoSwo2qRkXwmuStCoxg1";
    const auth = getAuth();
    const userRecord = auth.currentUser;
    try {
      console.log("UserRecord is", userRecord);

      for (const key in userRecord) {
        if (Object.hasOwnProperty.call(userRecord, key)) {
          console.log(`Key: ${key}, Value: ${userRecord[key]}`);
          //setResponse(`   Key: ${key}, Value: ${userRecord[key]}   `);
        }
      }
      // User data
      const userData = {
        uid: userRecord.uid,
        email: userRecord.email,
        emailVerified: userRecord.emailVerified,
        displayName: userRecord.displayName,
        providerId: userRecord.providerId,
        //customClaim: userRecord.customClaims,

        // Add more user properties as needed
      };
      console.log(userData.uid, userData.email);
      setResponse(userData);

      return userData;
    } catch (error) {
      // Handle errors here
      console.error("Error fetching user data:", error);
      throw error; // You can re-throw the error or handle it as needed
    }
  }
  //***************************************/
  //This verifies the role was actually set
  //***************************************/
  async function fetchUserRoleToken() {
    //const user = curentUser;
    const user = auth.currentUser;
    if (!user) {
      console.error("No user is currently logged in.");
      return null;
    }
    try {
      console.log("User is:", user);
      //console.log("User is", auth.currentUser.uid);
      getAuth()
        .getUser(user)
        .then((userRecord) => {
          // The claims can be accessed on the user record.
          console.log(userRecord.customClaims["role"]);
        });
      const idTokenResult = await user.getIdTokenResult();
      const userRole = idTokenResult.claims.role;
      setResponse(userRole);

      if (userRole) {
        console.log("User's role is:", userRole);
        setResponse(`Harry! The user Role is ${userRole}`);
        return userRole;
      } else {
        console.log("User has no role set.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching user role:", error);
      return null;
    }
  }

  //************************** */
  // This is the event handler
  //************************** */
  function onButtonClick(event) {
    // Prevent default if needed
    const auth = getAuth();
    const user = auth.currentUser.uid;
    setCurrentUser(user);
    setResponse("Waiting...");
    event.preventDefault();
    //let theUserUid = "7EeRFdVUAoSwo2qRkXwmuStCoxg1";
    let role = "SomeRoleNoSpace";
    //setCurrentUser(theUserUid);
    // Now call your function to set the role, passing in the expected values
    handleRoleSet(user, role);
  }

  // *******************************
  // This calls the firebase function
  // *******************************
  function handleRoleSet(userUid, role) {
    const requestData = {
      uid: userUid,
      role: role,
    };
    console.log("Before fetch here is role,", role);
    fetch(
      "https://us-central1-guest-artist-showcase-2024.cloudfunctions.net/setRole",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
        //body: requestData, // Pass the object directly
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to set role");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success!", data.message);
        setResponse(data.message);
      })
      .catch((error) => {
        console.error("Error setting role:", error);
      });
  }

  const handleHelloWorld = async () => {
    setResponse("");
    fetch(
      "https://us-central1-guest-artist-showcase-2024.cloudfunctions.net/helloWorld",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setResponse(data.message);
        console.log("Here is data from FB", data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  return (
    <Container className='mt-4 mb-5'>
      <h2>Responses</h2>
      <Row className='grad-bg mt-4 pt-3'>
        <Col className='bd-highlight'>
          <textarea
            className='form-control'
            type='text'
            value={response}
            rows={5}
            style={{ width: "100%" }} // Set the width to 100%
            maxLength={600}
          />
        </Col>
      </Row>

      <Row className='d-flex justify-content-between'>
        <Col className='d-flex'>
          <Button className='btn btn-primary mb-4' onClick={handleHelloWorld}>
            Test for Hello World
          </Button>
        </Col>

        <Col className='d-flex'>
          <Button className='btn btn-primary mb-4' onClick={onButtonClick}>
            Set Role with Firebase
          </Button>
        </Col>

        <Col className='d-flex justify-content-center'>
          <Button className='btn btn-primary mb-4' onClick={getUserRecord}>
            Get user Record
          </Button>
        </Col>

        <Col className='d-flex justify-content-center'>
          <Button className='btn btn-primary mb-4' onClick={fetchUserRoleToken}>
            Fetch User Role w/ Token
          </Button>
        </Col>
        <Col className='d-flex justify-content-end'>
          <Button className='btn btn-primary mb-4' onClick={getUserRole}>
            GetUser Role
          </Button>
        </Col>
      </Row>
      <Row>
        <p>UID: {response.uid}</p>
        <p>Email: {response.email}</p>
        <p>Display Name: {response.displayName}</p>
        <p>Provider Data: {response.providerId}</p>
        <p>Custom Claims: {response.customClaims}</p>
      </Row>
    </Container>
  );
};

export default TestFunctions;
